module.exports = __webpack_public_path__ + "img/svg/chevron-right.84033a1b87645abd7cbbd5a4f667bfeb.svg";